<template>
  <div id="editor-container"></div>
</template>

<script>
export default {
  name: "quill-input",
  props: {
    value: {
      type: String,
      default: "",
    },
    name: String,
  },
  data() {
    return {};
  },
  async mounted() {
    let Quill = await import("quill");
    Quill = Quill.default || Quill;
    this.$nextTick(() => {
      this.initialize(Quill);
    });
  },
  methods: {
    initialize(Quill) {
      this.editor = new Quill("#editor-container", {
        theme: "snow",
      });
    },
  },
};
</script>

<style>
</style>